import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import utils from "./utils";

// le decimos a vue que usaremos la libreria vuex
Vue.use(Vuex);

export default new Vuex.Store({
  // aca definimos nuestros estados, especie de variables
  state: {},
  // definimos los metodos para modificar (mutar) nuestros estados
  mutations: {},
  // definimos las acciones, funciones que hacen uso de nuestros estados
  actions: {},
  // definimos los modulos donde podremos organizar mejor nuestro ecosistema vuex
  modules: {
    auth,
    utils
  }
});
